import { useRef } from 'react';
import SwiperCore from 'swiper';
import { Navigation, Scrollbar } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';

import { ArticlesCarouselProps } from '.';
import FeaturedArticles from '../articles/FeaturedArticles';
import Button from '../buttons/Button';
import { NavigationNextIcon, NavigationPrevIcon } from '../icons';

export default function Carousel(props: ArticlesCarouselProps) {
  const { postobjectslist, anchor } = props;
  const swiperPrevRef = useRef<HTMLButtonElement>(null);
  const swiperNextRef = useRef<HTMLButtonElement>(null);

  return (
    <>
      <div className='absolute -top-11 right-0 flex items-center justify-center gap-2 pr-4 lg:-top-[54px]'>
        <Button
          variant='navigation'
          aria-label='Previous slide'
          ref={swiperPrevRef}
        >
          <NavigationPrevIcon className='pointer-events-none' fill='#ffffff' />
        </Button>
        <Button
          variant='navigation'
          aria-label='Next slide'
          ref={swiperNextRef}
        >
          <NavigationNextIcon className='pointer-events-none' fill='#ffffff' />
        </Button>
      </div>
      <div className='w-[150%] px-4 md:px-0'>
        <Swiper
          className='articles-carousel'
          modules={[Scrollbar, Navigation]}
          scrollbar={{
            hide: false,
            draggable: true,
          }}
          spaceBetween={30}
          slidesPerView={4}
          navigation={{
            nextEl: swiperNextRef.current,
            prevEl: swiperPrevRef.current,
          }}
          breakpoints={{
            768: {
              slidesPerView: 4,
              spaceBetween: 32,
            },
            1200: {
              slidesPerView: 5,
              spaceBetween: 40,
            },
            1403: {
              slidesPerView: 6,
              spaceBetween: 40,
            },
          }}
          onBeforeInit={(Swiper: SwiperCore) => {
            if (typeof Swiper.params.navigation !== 'boolean') {
              const navigation = Swiper.params.navigation;

              if (navigation) {
                navigation.prevEl = swiperPrevRef.current;
                navigation.nextEl = swiperNextRef.current;
              }
            }
          }}
        >
          {postobjectslist.map((articleObject, index: number) => (
            <SwiperSlide key={index}>
              <FeaturedArticles
                className='md:h-[400px]'
                title={articleObject?.postobjectitem?.title}
                titleSpan='8'
                titleSize='medium'
                slug={`/venture-technologies/${articleObject?.postobjectitem?.slug}`}
                featuredImage={articleObject?.postobjectitem?.featuredImage}
                data-aos='fade-in'
                data-aos-anchor={anchor || null}
                data-aos-delay={index * 100 + 300}
              />
            </SwiperSlide>
          ))}
          <SwiperSlide></SwiperSlide>
          <SwiperSlide></SwiperSlide>
        </Swiper>
      </div>
    </>
  );
}
